import { ckEditorDirective } from "./ng-ckeditor.directive";
import { NgCkEditorService } from "./ng-ckeditor.service";

export const ngCkEditor = angular
  .module("common.libs.ckeditor", [])
  .directive("ckeditor", ckEditorDirective)
  .service("NgCkEditorService", NgCkEditorService)
  .run(($q, $timeout, NgCkEditorService) => {
    "ngInject";

    if (angular.isUndefined(CKEDITOR)) {
      throw new Error("CKEDITOR not found");
    }
    CKEDITOR.disableAutoInline = true;
    function checkLoaded() {
      if (CKEDITOR.status === "loaded") {
        //                loaded = true;
        NgCkEditorService.setLoaded();
      } else {
        checkLoaded();
      }
    }

    CKEDITOR.on("loaded", checkLoaded);
    $timeout(checkLoaded, 100);
  })
  .config(() => {
    CKEDITOR.tools.array.find = function (array, fn, thisArg) {
      var length = array.length,
        i = 0;

      while (i < length) {
        if (fn.call(thisArg, array[i], i, array)) {
          return array[i];
        }
        i++;
      }

      return undefined;
    };
    CKEDITOR.config.language = "en";
    CKEDITOR.config.extraPlugins = "font,filebrowser";
    CKEDITOR.stylesSet.add("myStyle", [
      // Block-level styles
      {
        name: "Heading",
        element: "h1" /*styles: { color: 'var(--primary-#ccc)' }*/,
      },
      { name: "Subheading", element: "h2" /*, styles: { color: '#5f6e7d' }*/ },

      // Inline styles.
      //{ name: 'Subheading Text', element: 'span', styles: { color: 'var(--primary-#ccc)', 'font-size' : '15dp', 'line-height' : '80pt'} },
      //            { name: 'Content Text',element: 'span'/*, styles: { color: '#939ba4', 'font-size' : '15dp'}*/ },
      ////            { name: 'Web Link', element: 'a', styles: { color : '#648b1a' } },
      //            { name: 'Bullets', element: 'li', styles: { color : 'red' } },
      //            { name: 'Numbering', element: 'li', styles: { color : 'yellow' } },
    ]);
    // let font = 'font-family : "Roboto";';
    // CKEDITOR.addCss(".cke_editable { " + font + " }");
    CKEDITOR.addCss(".cke_editable h1{ color: var(--primary-#000); } ");
    CKEDITOR.addCss(
      '.cke_editable p, .cke_editable span{ color: #000; font-size : "1rem" ; margin:0 !important} '
    );
    CKEDITOR.addCss(".cke_editable a{ color: #0782C1;} ");
    CKEDITOR.addCss(".cke_editable h2{ color: #000; } ");
    CKEDITOR.addCss(".cke_editable ul li{ color: #000; } ");
    CKEDITOR.addCss(".cke_editable ol li{ color: var(--primary-#000); } ");
  }).name;



// WEBPACK FOOTER //
// ./src/app/common/libs/ng-ckeditor/ng-ckeditor.module.js